import { createEntityAdapter } from '@ngrx/entity';
import { Channel } from '@app/core/models';

export const channels = createEntityAdapter<Channel.Channel>({
  selectId: (channel) => channel.name,
  sortComparer: (channel1, channel2) =>
    channel2.latestMsg.dateTime.localeCompare(channel1.latestMsg.dateTime),
});
